"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownContractSource = void 0;
class UnknownContractSource {
    constructor(type, workchain, description) {
        this.backup = () => {
            throw Error('Unknown');
        };
        this.describe = () => {
            return this.description;
        };
        this.type = type;
        this.workchain = workchain;
        this.description = description;
    }
    get initialCode() {
        throw Error('Unknown');
    }
    get initialData() {
        throw Error('Unknown');
    }
}
exports.UnknownContractSource = UnknownContractSource;
